// extracted by mini-css-extract-plugin
module.exports = {"section":"VS_section__MsxAQ"};